import Cookies from 'js-cookie';

import { removeCredential } from './credentialsStorage';

type RemoveCookieProps = { keys: string[] };

/**
 * Removes multiple cookies with the specified keys.
 * @function removeCookieValues
 * @param {RemoveCookieProps} props - An object containing an array of keys for cookies to be removed.
 * Each key represents the cookie name to be removed.
 *
 * Also drops the `credentialsStorage` mirror. Every credential cleanup MUST reach both
 * layers: clearing only the cookie would leave the value alive in storage, and the next
 * read would resurrect it — the user would come back authenticated after logging out.
 */
const removeCookieValues = ({ keys }: RemoveCookieProps) => {
  keys.forEach((key) => {
    Cookies.remove(key, {
      domain : '.ingresse.com',
      path : '/',
      secure : true,
      sameSite : 'None'
    });

    removeCredential(key);
  });
};

export { removeCookieValues };
